export enum Tabs {
  All = 'All',
  Agreements = 'Agreements',
  Listings = 'Listings',
  Archive = 'Archive',
}

export enum ListingTabs {
  ListingDetails = 'ListingDetails',
  Contracts = 'Contracts',
  Launch = 'Launch',
}
